import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, switchMap, throwError, take } from 'rxjs';
import { inject } from '@angular/core';
import { AuthApiService } from '../services/auth/auth-api.service';

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthApiService);
  const HTTP_UNAUTHORIZED = 401;
  const TAKE_ONE = 1;

  const isTokenExpired = (error: HttpErrorResponse): boolean =>
    error.status === HTTP_UNAUTHORIZED && error.error?.message === 'Le token a expiré.' && !req.url.includes('/refresh-token');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isTokenExpired(error)) {
        const refreshToken = authService.getRefreshToken();

        if (!refreshToken) {
          authService.logout$().pipe(take(TAKE_ONE))
            .subscribe();
          return throwError(() => error);
        }

        return authService.refreshTokens$(refreshToken).pipe(
          switchMap((newAccessToken: string) => {
            const clonedRequest = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${newAccessToken}`),
            });
            return next(clonedRequest);
          }),
          catchError(refreshError => {
            console.error('Échec du refresh token :', refreshError);
            authService.logout$().pipe(take(TAKE_ONE))
              .subscribe();
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
}
